import Header from '../components/Header';
import Landing from '../components/Landing';


const HomePage = () => {
    return (
        <>
            <Landing />
        </>
    )
};

export default HomePage;